<template>
    <div>
        <info-modal
            ref="infoModal"
            :msg="infoMsg"
            @ok-submit="closeupdatedStauts"
        />

        <liff-error-modal
            ref="errorModal"
            :msg="errorMsg"
        />

        <info-modal-display-object
            ref="overlapDisplay"
            :groupOverlap="errorOverlap"
        />

        <div class="bg-leave-liff">
            <div class="page-container">
                <div class="head-content">
                    <div
                        @click="backToTableList"
                        class="back-button">
                        <v-icon
                        color="primary"
                        size="24">
                        arrow_back_ios
                        </v-icon>
                        <span color="primary">{{ $vuetify.lang.t('$vuetify.checkInOutApproval.back') }}</span>
                    </div>
                </div>
                <div>
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.checkInOutApproval.firstLastName') }}
                    </span>
                    <v-text-field
                        :value="name"
                        readonly
                        solo
                        height="40px">
                    </v-text-field>
                </div>
                <div>
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.checkInOutApproval.requestType') }}
                    </span>
                    <v-text-field
                        :value="requestType"
                        readonly
                        solo
                        height="40px">
                    </v-text-field>
                </div>
                <div>
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.checkInOutApproval.forgetDate') }}
                    </span>
                    <v-text-field
                        :value="date"
                        readonly
                        solo
                        height="40px">
                    </v-text-field>
                </div>
                <div :class="{'d-flex': isCheckInOut}">
                    <div>
                        <span class="label-tag">
                            {{ $vuetify.lang.t(this.isCheckIn ? '$vuetify.checkInOutLater.checkInTime' : '$vuetify.checkInOutLater.checkOutTime') }}
                        </span>
                        <v-text-field
                            :value="selectedRequestType"
                            readonly
                            solo
                            height="40px">
                        </v-text-field>
                    </div>
                    <div v-if="isCheckInOut" class="pl-4">
                        <span class="label-tag">
                            {{ $vuetify.lang.t('$vuetify.checkInOutApproval.checkOutTime') }}
                        </span>
                        <v-text-field
                            :value="checkOutTime"
                            readonly
                            solo
                            height="40px">
                        </v-text-field>
                    </div>
                </div>
                <div>
                    <span class="label-tag">
                        {{ $vuetify.lang.t('$vuetify.checkInOutApproval.description') }}
                    </span>
                    <v-text-field
                        :value="description"
                        readonly
                        solo
                        height="40px">
                    </v-text-field>
                </div>
                <div class="flex-center">
                    <v-btn
                    class="margin-rigth"
                    @click="updateStatus('REJ')">
                        {{ $vuetify.lang.t('$vuetify.checkInOutApproval.reject') }}
                    </v-btn>
                    <v-btn
                    color="primary"
                    @click="updateStatus('APV')">
                        {{ $vuetify.lang.t('$vuetify.checkInOutApproval.approve') }}
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import InfoModal from '@/components/modal/InfoModal'
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import InfoModalDisplayObject from '@/components/modal/InfoModalDisplayObject'

export default {
    name: 'CheckInOutApprovalDetail',

    props: {
        requestNo: {
            type: String,
            default: ''
        },

        lineId: {
            type: String,
            default: ''
        }
    },

    components: {
        InfoModal,
        LiffErrorModal,
        InfoModalDisplayObject
    },

    data () {
        return {
            name: null,
            requestType: null,
            date: null,
            checkInTime: null,
            checkOutTime: null,
            description: null,
            isCheckIn: null,
            isCheckInOut: null,
            infoMsg: '',
            errorOverlap: {},
            errorMsg: ''
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },

        selectedRequestType: {
            get () {
                return this.isCheckIn ? this.checkInTime : this.checkOutTime
            },
            set (value) {
                this.isCheckIn ? this.checkInTime = value : this.checkOutTime = value
            }
        }
    },

    methods: {
        async getRequestInfo () {
            this.$store.dispatch('setLoading', true)
            const getDetailUrl = `${process.env.VUE_APP_BACKEND}/attendance-detail-line?lineId=${this.lineId}&requestNo=${this.requestNo}`
            const res = await axios.get(getDetailUrl)
            if (res && res.data && res.data.status === 'ok') {
                this.transformData(res.data.data)
            }
            this.$store.dispatch('setLoading', false)
        },

        transformData (mRequestList) {
            if (mRequestList.requestType === 'MRN') {
                this.isCheckIn = true
                this.$vuetify.lang.current === 'en' ? this.requestType = 'Check In' : this.requestType = 'เวลาเข้างาน'
            } else if (mRequestList.requestType === 'ATN') {
                this.isCheckIn = false
                this.$vuetify.lang.current === 'en' ? this.requestType = 'Check Out' : this.requestType = 'เวลาออกงาน'
            } else if (mRequestList.requestType === 'FUL') {
                this.isCheckIn = true
                this.isCheckInOut = true
                this.$vuetify.lang.current === 'en' ? this.requestType = 'Check In - Check Out' : this.requestType = 'เวลาเข้า - ออกงาน'
            }

            this.name = mRequestList.fullname
            this.date = mRequestList.submittedDate
            this.checkInTime = mRequestList.startTime
            this.checkOutTime = mRequestList.endTime
            this.description = mRequestList.description
        },

        backToTableList () {
            this.$emit('back-button')
        },

        closeupdatedStauts () {
            this.$emit('updated-status')
        },

        async updateStatus (status) {
            this.$store.dispatch('setLoading', true)
            const res = await axios.put(
                `${process.env.VUE_APP_BACKEND}/attendance-review-line/approval`,
                {
                    lineId: this.lineId,
                    status: status,
                    requestNo: this.requestNo
                }
            )
            if (res && res.data && res.data.status === 'ok') {
                this.$refs.infoModal.dialog = true
                this.infoMsg = res.data.msg
            } else if (res && res.data && res.data.status === 'error_overlap') {
                this.$refs.overlapDisplay.dialog = true
                this.errorOverlap = res.data.errors
            } else if (res && res.data && res.data.status === 'error') {
                this.$refs.errorModal.dialog = true
                this.errorMsg = res.data.msg
            }

            this.$store.dispatch('setLoading', false)
        }
    },

    async mounted () {
        await this.getRequestInfo()
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                if (after === 'en') {
                    if (this.requestType === 'เวลาเข้างาน') this.requestType = 'Check In'
                    else if (this.requestType === 'เวลาออกงาน') this.requestType = 'Check Out'
                    else if (this.requestType === 'เวลาเข้า - ออกงาน') this.requestType = 'Check In - Check Out'
                } else {
                    if (this.requestType === 'Check In') this.requestType = 'เวลาเข้างาน'
                    else if (this.requestType === 'Check Out') this.requestType = 'เวลาออกงาน'
                    else if (this.requestType === 'Check In - Check Out') this.requestType = 'เวลาเข้า - ออกงาน'
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}

.head-content {
    color: #D76436;
    display: flex;
    padding-bottom: 1rem;
    justify-content: space-between;
    align-items: center;
}

.flex-center {
    display: flex;
    justify-content: center;
    height: 40px;
}

.margin-rigth {
    margin-right: 16px;
}

.file-lao {
    display: none;
}

.bg-leave-liff {
    height: 100vh;
    background-color: #2E2929;
    color: #ffffff;

    .header-text {
        font-family: LexendDeca;
        font-size: 20px;
        padding: 1rem;
        height: 10%;
        min-height: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .page-container {
        background: #ffffff;
        padding: 2rem;
        color: #6c6c6c;
        font-size: 14px;
        font-weight: normal;
        overflow: scroll;
        height: 100%;
    }

    .label-tag {
        font-size: 14px;
        color: #757575;
    }
}

.lang {
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    &-th{
        font-family: Prompt;
    }
    &-en{
        font-family: LexendDeca;
    }
}

.text-underline {
    text-decoration: underline;
    color: #d76436;
}
</style>
